import QuestionnaireFilterForm from "./QuestionnaireFilterForm"
import QuestionnaireTable from "../../views/questionnaire/QuestionnaireTable"
import { Theme } from "../../../misc/Theme"

// Returns list of questionnaires

export default function QuestionnaireSelectMultipleField ({
    value,
    highlightedOptions = [],
    onRowClick = (uid: string) => {},
    onChange = (uids: string[]) => {}
}) {

    const toggle = (uid) => {
        var selected = !!value.find(qu => qu === uid)
        var newList = selected ? value.filter(u => u !== uid) : [...value, uid]  
        onChange(newList)
    }

    return (
        <div style={{display: "grid", gap: "10px"}}>
            <div>
                <p>
                    {highlightedOptions?.length ? (
                        <>Relevant Questionnaires will be in <b>bold</b>. </>
                    ) : null}

                    Some columns may be filtered by a range of options
                    <span style={{height: "16px", lineHeight: "16px", fontSize: "10px", color: "white", backgroundColor: Theme.palette.error.main, padding: "0px 6px 0 6px", margin: "0 4px", borderRadius: "12px", fontWeight: 600}}>
                        1
                    </span>.
                </p>

                <QuestionnaireFilterForm />
            </div>

            <QuestionnaireTable 
                size="sm" 
                width="400px" 
                height="300px" 
                selectedOptions={value}
                highlightedOptions={highlightedOptions}
                onCheckboxClick={(questionnaireUid) => toggle(questionnaireUid)} 
                onRowClick={(questionnaireUid) => onRowClick(questionnaireUid)}/>
        </div>
    )
}